// src/utils/money.js — money helpers shared across billing, printing and admin
// Prices are kept exactly as entered (to the paisa). Only the FINAL bill total is rounded to whole rupees, after GST.
export const GST_RATE = 0.05; // 2.5% CGST + 2.5% SGST

export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// 253 -> "253", 253.3 -> "253.30"
export const fmt = (n) => {
  const v = round2(n);
  return Number.isInteger(v) ? String(v) : v.toFixed(2);
};

// Price of a size that has no custom price: base × multiplier, kept to the paisa (not rounded to whole rupees)
export const autoSizePrice = (base, mult) => round2((Number(base) || 0) * mult);